var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSoundOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-298 -464) translate(5 71) translate(293 393) translate(5 6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M8.425.045c-.227-.092-.488-.041-.661.129L3.038 4.788H.607c-.335 0-.607.265-.607.592v5.238c0 .327.272.593.607.593h2.43l4.727 4.616c.116.113.271.173.43.173.077 0 .156-.015.231-.045.227-.092.375-.308.375-.547V.593c0-.24-.148-.456-.375-.548"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L5.6 5.6",
    transform: "translate(12.089 5.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L5.6 5.6",
    transform: "translate(12.089 5.2) matrix(1 0 0 -1 0 5.6)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSoundOff);
export default __webpack_public_path__ + "static/media/ic-sound-off.a4ed652784a28732d594c793ef990e5a.svg";
export { ForwardRef as ReactComponent };